module.exports = __webpack_public_path__ + "static/img/case-banner.d69e2a52.jpg";